/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from './config/constants'
import ArgonDashboard from './plugins/argon-dashboard'
import Multiselect from 'vue-multiselect'
import flatPicker from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import VueCarousel from 'vue-carousel'
import JsonCSV from 'vue-json-csv'
import ListGroupPlugin  from 'bootstrap-vue'
import FormFilePlugin  from 'bootstrap-vue'
import CardPlugin from 'bootstrap-vue'
import CollapsePlugin  from 'bootstrap-vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);
Vue.use(CollapsePlugin)
Vue.use(FormFilePlugin)
Vue.component('multiselect', Multiselect)
Vue.component('flatPicker', flatPicker)
Vue.use(ArgonDashboard)
Vue.use(VueCarousel)
Vue.component('downloadCsv', JsonCSV)
Vue.use(ListGroupPlugin)
Vue.use(CardPlugin)
new Vue({
    components: {Multiselect,flatPicker},
    return: {

        constants: {},
        full_url: ''

    },
    router,

    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    },
    render: h => h(App)
}).$mount('#app')

